import React from 'react';
import { Award, Heart, Sparkles, Users } from 'lucide-react';
import { aboutContent } from '@/hooks/useContent';

// Icon mapping
const iconMap = {
  Award: Award,
  Heart: Heart,
  Sparkles: Sparkles,
  Users: Users,
};

const About = () => {
  const content = aboutContent;

  return (
    <section 
      id="about" 
      className="py-24"
      style={{ backgroundColor: content.background?.color || '#FFFFFF' }}
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 
              className="section-title text-4xl md:text-5xl font-bold mb-6"
              data-testid="about-title"
            >
              {content.title}
            </h2>
            <p className="text-lg mb-6 leading-relaxed" style={{ color: '#736c64' }}>
              {content.story_1}
            </p>
            <p className="text-lg mb-6 leading-relaxed" style={{ color: '#736c64' }}>
              {content.story_2}
            </p>
            <p className="text-lg mb-8 leading-relaxed" style={{ color: '#736c64' }}>
              {content.story_3}
            </p>

            {/* Highlights Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {content.highlights?.map((item, index) => {
                const IconComponent = iconMap[item.icon] || Sparkles;
                return (
                  <div key={index} className="flex items-start gap-4" data-testid={`about-highlight-${index}`}>
                    <div className="flex-shrink-0 about-icon-wrapper">
                      <IconComponent size={32} />
                    </div>
                    <div>
                      <h4 className="font-bold text-base mb-1" style={{ color: '#1e1919' }}>
                        {item.title}
                      </h4>
                      <p className="text-sm" style={{ color: '#736c64' }}>
                        {item.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="about-image-wrapper rounded-lg overflow-hidden shadow-2xl">
              <img 
                src={content.image}
                alt={content.image_alt}
                className="w-full h-full object-cover"
                data-testid="about-image"
              />
            </div>
            {/* Decorative element */}
            <div 
              className="absolute -bottom-6 -right-6 w-48 h-48 rounded-lg -z-10"
              style={{ backgroundColor: '#61525a20' }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
